import { useEffect, useState } from "react"
import "./AvailableInLPComponent.scss"
import ProductCardComponent from "../../../ProductCard/ProductCardComponent"
import { useDispatch, useSelector } from "react-redux"
import { getAvailableLPByEntityID, getAvailableLPByEntityIDClear } from "../../../../../redux/assignCourse/actions"
import { ProductCardPriceInfo, SessionKeys, convertTimeFormat, convertTimeInHourAndMin, getProcureInfo, goToLPDetailUtil } from "../../../../../utils/AppUtils"
import _ from "lodash";
import NotFoundComponent from "../../../NotFound/NotFoundComponent"
import { useNavigate } from "react-router-dom"

const AvailableInLPComponent = (props) => {

    const {
        id, code, source, type, isMobile
    } = props

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true)
    const [productArr, setProductArr] = useState([
        {
            tagsArray: [],
            showHeader: true,
            showBody: false,
            showFooter: false,
            showProgresss: false,
            cardClassName: "col-12 col-lg-12",
            isLoading: true
        },
        {
            tagsArray: [],
            showHeader: true,
            showBody: false,
            showFooter: false,
            showProgresss: false,
            cardClassName: "col-12 col-lg-12",
            isLoading: true
        }
        // {
        //     title: 'NAR Pricing Strategy Advisor PSA - Certification by CRE',
        //     logoURL: '/images/newImages/eloitt-icon.svg',
        //     bannerURL: '/images/newImages/img-I.svg',
        //     tagsArray: ['Deloitte', 'Virtual'],
        //     description: '',
        //     btnTitle: 'Explore',
        //     btnAction: () => {},
        //     descAction: () => {},
        //     bannerAction: () => {},
        //     footerLineComp: () => {},
        //     showHeader: true,
        //     showProgress: false,
        //     showBody: false,
        //     showFooter: false,
        //     cardClassName: 'w-100',
        // },
        // {
        //     title: 'Large lots - Sales tactics for new real estate agents',
        //     logoURL: '/images/newImages/eloitt-icon.svg',
        //     bannerURL: '/images/newImages/img-II.svg',
        //     tagsArray: ['Xsel', 'Course', '4 modules', '1hr 25m'],
        //     description: '',
        //     btnTitle: 'Explore',
        //     btnAction: () => {},
        //     descAction: () => {},
        //     bannerAction: () => {},
        //     footerLineComp: () => {},
        //     showHeader: true,
        //     showProgress: false,
        //     showBody: false,
        //     showFooter: false,
        //     cardClassName: 'w-100',
        // },
    ])
    const availableLPByEntityId = useSelector(state => state.assignCourse.availableLPByEntityId)

    useEffect(() => {
        if (id && source && type && (localStorage.getItem(SessionKeys.API_TOKEN_BROKER)||localStorage.getItem(SessionKeys.API_TOKEN))) {
            dispatch(
                getAvailableLPByEntityID({
                    module: "getAvailableLP",
                    postData: {
                        token: isMobile ?  localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                        entity_id: id,
                        type: type,
                        source: source,
                    }
                })
            )
        } else if (!localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
            setProductArr([])
        }
    }, [dispatch, id, source, type])

    const bannerClicked = () => {
        console.log('Banner Image clicked')
    }

    const footerClicked = () => {
        console.log('Clicked Explore Button')
    }
    const footerLineComp = () => {
        return (
            <span className="signup-btn">Free with paid subscriptions</span>
        )
    }

    useEffect(() => {
        console.log('AVAILBALE LP', availableLPByEntityId)
        if (!_.isEmpty(availableLPByEntityId)) {
            if (availableLPByEntityId.status === 'success') {
                const payload = availableLPByEntityId.payload.payload;
                if (!_.isEmpty(payload)) {
                    console.log(payload)
                    let prodArr = formatLPData(payload)
                    
                    setProductArr(prodArr)
                } else {
                    // setCatTagsArray([])
                    setProductArr([])
                }
            } else {
                // setCatTagsArray([])
                setProductArr([])
            }
            dispatch(getAvailableLPByEntityIDClear())
            setIsLoading(false)
        }
    }, [availableLPByEntityId])

    const formatLPData = (lpData) => {
        let lpArr = [];
        let records = lpData;
        for (let lp of records) {
          let tags = [];
          let logoURL = "";
          let btnTitle = "Explore";
          if (!_.isEmpty(lp.provider)) {
            tags.push(lp.provider.provider_display_name);
            logoURL = lp.provider.provider_img;
          }
          tags.push(`${"Learning Path"}`);
    
          if (lp.course_count) {
            tags.push(`${lp.course_count} Course${lp.course_count > 1 ? "s" : ""}`);
          }
          if (lp.video_count) {
            tags.push(`${lp.video_count} Video${lp.video_count > 1 ? "s" : ""}`);
          }
          if (lp.level_count) {
            tags.push(`${lp.level_count} Level${lp.level_count > 1 ? "s" : ""}`);
          }
          if (lp.event_count) {
            tags.push(`${lp.event_count} Event${lp.event_count > 1 ? "s" : ""}`);
          }
          if (lp.duration) {
            tags.push(convertTimeFormat(lp.duration, true));
          }
          let priceInfo = getProcureInfo(lp.purchased_info);
          lp.priceInfo = priceInfo
    
          lpArr.push({
            id: lp?.id,
            is_like: lp?.is_like ? lp?.is_like : false,
            is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
            dbId: lp?.list_id,
            productType: "learningpath",
            productOrigin: lp?.origin,
            title: lp.name,
            logoURL: logoURL,
            logoAlText: "LP",
            bannerURL: lp.thumbnail,
            tagsArray: tags,
            description: lp.description,
            duration: "",
            showHeader: true,
            showProviderIcon: true,
            showLikeMenu: true,
            showPlayButton: false,
            showProgress: true,
            showBody: false,
            showFooter: true,
            progress: lp.learn_progress,
            btnTitle: btnTitle,
            btnAction: () => goToLPDetailUtil(lp,navigate,0,isMobile),
            descAction: () => goToLPDetailUtil(lp,navigate,0,isMobile),
            bannerAction: () => goToLPDetailUtil(lp,navigate,0,isMobile),
            cardClassName: "",
            footerLineComp: !_.isEmpty(priceInfo) ? 
            ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)  : "",
            isLoading: false,
            priceInfo: priceInfo,
            rightBtnIcon: "/images/arrow-right.svg",
            lefttBtnIcon: "",
          });
        }

        return lpArr;
    
    };

    const goToLPDetail = (lpInfo) => {
        let paramsReq ={
            lp_id: lpInfo.id,
            is_level: "false",
            source: lpInfo?.origin
          }
          let jsonString = JSON.stringify(paramsReq);
          let encodedUrl = btoa(jsonString);
        navigate(
          `/lpDetail?c=${encodedUrl}`
        );
      };

    

    return (
        <>
            {sessionStorage.getItem(SessionKeys.IS_TOUR) !== "YES" && <div className="available-lp">
                <div className="title-lp">Available in Learning Path</div>
                {
                    productArr.length > 0 ?
                    productArr.map((product, i) => {
                        return (
                            <ProductCardComponent 
                                key={`product-lp-${i+1}`} 
                                {...product}
                                isCol12={true}
                            />
                        )
                    })
                    :
                    <NotFoundComponent
                        width={200}
                        height={219}
                        showBtn={false}
                        showMsg={true}
                        msgLine={'Nothing here, yet.'}
                    />
                }
            </div>}
        </>
    )
}

export default AvailableInLPComponent